export var EField;
(function (EField) {
    EField["Address"] = "address";
    EField["DateOfBirth"] = "dateOfBirth";
    EField["Nationality"] = "nationality";
})(EField || (EField = {}));
